import React from "react";
import styled from "styled-components";
import { CommonLabel, ErrorText, TextInputWitWhiteBackGround } from "../styles";
import { Controller, useFormContext } from "react-hook-form";
import { useLanguage } from "../../../../hooks/useLanguage";
import { TEXT_INPUT_PATTERN } from "../step3/utils";

const HiddenResponsiveLabel = styled(CommonLabel)`
  opacity: 0;

  @media (max-width: 855px) {
    display: none;
  }
`;

export default function TextInputWithLanguageControl(props) {
  const {
    name,
    label,
    rules,
    isDark,
    isLabelHidden,
    customLabel,
    showNonEmptyError,
    handleKeydown,
    ...other
  } = props || {};
  const { isContentGeorgian } = useLanguage();
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => {
        const isError = shouldShowError();

        function shouldShowError() {
          if (showNonEmptyError) {
            if (error) {
              return true;
            }
          } else {
            return error && !field.value;
          }
        }

        return (
          <>
            {customLabel ||
              (isLabelHidden ? (
                <HiddenResponsiveLabel htmlFor={name}>
                  {label}
                </HiddenResponsiveLabel>
              ) : (
                <CommonLabel htmlFor={name}>{label}</CommonLabel>
              ))}
            <TextInputWitWhiteBackGround
              {...field}
              {...other}
              isDark={isDark}
              id={name}
              error={isError}
              onKeyDown={(e) => {
                if (typeof handleKeydown === "function") {
                  handleKeydown(e);
                  return;
                }
                if (e.key === " " && e.target.value.length === 0) {
                  e.preventDefault();
                }
              }}
              onChange={(e) => {
                if (!isContentGeorgian) {
                  const cleaned = e.target.value.replace(
                    TEXT_INPUT_PATTERN,
                    ""
                  );
                  field.onChange(cleaned);
                } else {
                  field.onChange(e);
                }
              }}
            />
            <ErrorText error={isError}>
              {isError ? error?.message : "error placeholder"}
            </ErrorText>
          </>
        );
      }}
    />
  );
}
